import Modal from 'bootstrap/js/dist/modal';

const app = document.querySelector('[data-watcher-app]');

if (app) {
    const list = app.querySelector('[data-watcher-list]');
    const loading = app.querySelector('[data-watcher-loading]');
    const empty = app.querySelector('[data-watcher-empty]');
    const message = app.querySelector('[data-watcher-message]');
    const modalElement = app.querySelector('[data-watcher-modal]');
    const modal = new Modal(modalElement);
    const form = app.querySelector('[data-watcher-form]');
    const input = form.querySelector('[name="query"]');
    const submit = form.querySelector('[data-watcher-submit]');
    const formError = form.querySelector('[data-watcher-form-error]');
    let editingId = null;
    let watchers = [];

    const setFormError = (text) => {
        if (formError) {
            formError.textContent = text;
        }
        input?.classList.toggle('is-invalid', Boolean(text));
    };

    const request = async (url, options = {}) => {
        const response = await fetch(url, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                ...options.headers,
            },
            ...options,
        });
        const payload = await response.json();
        if (!response.ok) {
            throw new Error(payload.message || 'Er ging iets mis.');
        }
        return payload.data;
    };

    const showMessage = (text, type = 'success') => {
        if (!message) {
            return;
        }

        message.textContent = text;
        message.className = `alert alert-${type}`;
        window.setTimeout(() => message?.classList.add('d-none'), 4500);
    };

    const render = () => {
        loading.classList.add('d-none');
        list.classList.toggle('d-none', watchers.length === 0);
        empty.classList.toggle('d-none', watchers.length !== 0);
        list.innerHTML = watchers.map((watcher) => {
            const deal = watcher.deal;
            const title = deal?.title || 'Product wordt opgezocht';
            const iboodUrl = deal?.slug && deal?.classic_id ? `https://www.ibood.com/nl/s-nl/o/${encodeURIComponent(deal.slug)}/${encodeURIComponent(deal.classic_id)}` : null;
            const endsAt = deal?.ends_at ? new Intl.DateTimeFormat('nl-NL', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(deal.ends_at)) : null;
            const status = deal?.status || 'pending';
            const statusLabel = { approved: 'Goedgekeurd', rejected: 'Niet geselecteerd', failed: 'Validatie mislukt', pending: 'In afwachting' }[status] || status;
            const badge = status === 'approved' ? 'success' : status === 'rejected' ? 'secondary' : status === 'failed' ? 'danger' : 'warning';
            return `<div class="col-12 col-lg-6">
                <article class="watcher-card h-100">
                    <div class="d-flex justify-content-between gap-3">
                        <div class="watcher-icon"><i class="bi bi-bell"></i></div>
                        <span class="badge text-bg-${badge}">${statusLabel}</span>
                    </div>
                    <p class="watcher-id mt-3 mb-1">Zoekterm</p>
                    <p class="watcher-query mb-2">${escapeHtml(watcher.query || `Product-ID ${watcher.ibood_id}`)}</p>
                    <h3 class="h5 mb-3">${iboodUrl ? `<a href="${escapeHtml(iboodUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(title)}</a>` : escapeHtml(title)}</h3>
                    ${deal?.brand ? `<p class="watcher-meta mb-2"><strong>Merk:</strong> ${escapeHtml(deal.brand)}</p>` : ''}
                    ${deal?.current_price ? `<p class="watcher-price mb-3">€ ${escapeHtml(deal.current_price)} <small>iBOOD-prijs</small></p>` : '<p class="text-secondary mb-3">Nog geen dealgegevens beschikbaar.</p>'}
                    ${deal?.delivery_price !== null && deal?.delivery_price !== undefined ? `<p class="watcher-meta mb-2"><strong>Verzending:</strong> € ${escapeHtml(deal.delivery_price)}</p>` : ''}
                    ${endsAt ? `<p class="watcher-meta mb-2"><strong>Einde aanbieding:</strong> ${escapeHtml(endsAt)}</p>` : ''}
                    ${deal?.ai_reason ? `<p class="watcher-reason mb-3"><strong>Beoordeling:</strong> ${escapeHtml(deal.ai_reason)}</p>` : ''}
                    <div class="d-flex gap-2 mt-auto">
                        <button class="btn btn-sm btn-outline-dark" type="button" data-edit="${watcher.id}"><i class="bi bi-pencil me-1"></i> Bewerken</button>
                        <button class="btn btn-sm btn-outline-danger" type="button" data-delete="${watcher.id}"><i class="bi bi-trash me-1"></i> Verwijderen</button>
                    </div>
                </article>
            </div>`;
        }).join('');
    };

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' }[character]));

    const load = async () => {
        try {
            watchers = await request('/ibood/watchers/data');
            render();
        } catch (error) {
            loading?.classList.add('d-none');
            showMessage(error.message, 'danger');
        }
    };

    app.querySelector('[data-watcher-new]').addEventListener('click', () => {
        editingId = null;
        form.reset();
        setFormError('');
        app.querySelector('[data-watcher-modal-title]').textContent = 'Watcher toevoegen';
        modal.show();
    });

    list.addEventListener('click', async (event) => {
        const edit = event.target.closest('[data-edit]');
        const remove = event.target.closest('[data-delete]');
        if (edit) {
            const watcher = watchers.find((item) => item.id === Number(edit.dataset.edit));
            editingId = watcher.id;
            input.value = watcher.query || watcher.ibood_id || '';
            app.querySelector('[data-watcher-modal-title]').textContent = 'Watcher bewerken';
            modal.show();
        }
        if (remove && window.confirm('Deze watcher verwijderen?')) {
            try {
                await request(`/ibood/watchers/${remove.dataset.delete}`, { method: 'DELETE' });
                watchers = watchers.filter((item) => item.id !== Number(remove.dataset.delete));
                render();
                showMessage('Watcher verwijderd.');
            } catch (error) {
                showMessage(error.message, 'danger');
            }
        }
    });

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        submit.disabled = true;
        setFormError('');
        try {
            const watcher = await request(editingId ? `/ibood/watchers/${editingId}` : '/ibood/watchers', {
                method: editingId ? 'PUT' : 'POST',
                body: JSON.stringify({ query: input.value.trim() }),
            });
            if (editingId) watchers = watchers.map((item) => item.id === watcher.id ? watcher : item);
            else watchers.unshift(watcher);
            render();
            modal.hide();
            showMessage(editingId ? 'Watcher bijgewerkt.' : 'Watcher toegevoegd.');
        } catch (error) {
            setFormError(error.message);
        } finally {
            submit.disabled = false;
        }
    });

    load();
}